export default {
  SET_USER: (state, user) => {
    state.user = user;
  },
};
